import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5v18h14V3zm-2 16H7V5h10v14z"
}), 'CropPortraitSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropPortraitSharp.js
// module id = 3028
// module chunks = 2